import * as Yup from "yup";

export function getAuthInitialValues(obj) {
  return {
    email: obj?.email || "",
    password: obj?.password || "",
    confirmPassword: obj?.confirmPassword,
  };
}

const VALIDATION_SCHEMA = (locale)=>Yup.object().shape({
  password: Yup.string()
    .label(locale('password'))
    .required(locale('passwordRequired'))
    .matches(/[a-z]+/, locale('passwordLowerCase'))
    .matches(/[A-Z]+/, locale('passwordUpperCase'))
    .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, locale('passwordSymbol'))
    .matches(/\d+/, locale('passwordNumeral'))
    .min(8, locale('passwordMinLength'))
    .max(20, locale('passwordMaxLength')),
  confirmPassword: Yup.string().trim()
    .required(locale('confirmPasswordRequired'))
    .oneOf(
      [Yup.ref("password"), null],
      locale('passwordMismatch')
    ),
});

export { VALIDATION_SCHEMA };
